import http from "../../http-common";

class EmployeeLifecycleService {
  search(params) {
    return http.get("/employees/lifecycle/events", {params});
  }

  searchAdmin(params) {
    return http.get("/employees-master/lifecycle/events", {params});
  }
}

export default new EmployeeLifecycleService();
